<template>
  <Error icon-name="no-records" title="Oops!" data-test-id="no-data-error">
    <Stack direction="col" gap="xs">
      <Text align="center" :data-test-id="dataTestId">Looks like you don’t have any {{ documentType }}.</Text>
      <Text align="center">
        If you think this is a mistake please contact the {{ accountBranch?.name }} branch on
        <Text tag="span" class="text-mkm-blue-light" data-test-id="ordersBranchPhone">
          {{ accountBranch?.contacts.phone }}
        </Text>
      </Text>
    </Stack>
  </Error>
</template>

<script lang="ts" setup>
import { NoDocumentsProps } from "./noDocumentsTypes";

const { documentType, dataTestId } = defineProps<NoDocumentsProps>();

const { accountBranch } = useBranches();
</script>
